// extracted by mini-css-extract-plugin
export default {"subheadingDefault":"AccordionWithSubheading_subheadingDefault__LvnKJ"};